import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {VorhersageHeute, VorhersageTag} from '../../../../../../../model/vorhersagen/vorhersage-zehn-tage';
import {DatastoreService} from '../../../../../../../service/datastore/datastore.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {CommonConstants} from '../../../../../../../util/common-constants';
import {WerteConverterUtil} from '../../../../../../../util/werte-converter-util';

@Component({
  selector: 'app-24h-vorhersage-table',
  templateUrl: './vierundzwanzig-stunden-vorhersage-table.component.html',
  styleUrls: ['../../vorhersagen-table-styles.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class VierundzwanzigStundenVorhersageTableComponent implements OnInit {

  displayedColumns = CommonConstants.VORHERSAGE_TABLE_COLUMNS_TO_DISPLAY;

  dataSource = new MatTableDataSource<VorhersageTag>();

  expandedElement: VorhersageTag | null;

  @Input() vorhersageTage: VorhersageTag[];

  constructor(public datastoreService: DatastoreService, public werteConverter: WerteConverterUtil) {
  }

  ngOnInit(): void {
    this.dataSource.data = this.vorhersageTage;
  }

}
